"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var DataQualityStatusChip_1 = require("../../dataQuality/DataQualityStatusChip");
var DataQualityType_1 = require("../../dataQuality/DataQualityType");
var TypescriptHelpers_1 = require("../../utils/TypescriptHelpers");
function RenderWarningsFromGraphAndVizportal(props) {
    var warning = !!props.anchored ? [props.anchored] : [];
    var upstream = props.upstreamWarnings.map(function (f) { return mapFragmentToDetail(f, false, props.urls); });
    return React.createElement(RenderWarnings, __assign({}, props, { details: warning.concat(upstream) }));
}
exports.RenderWarningsFromGraphAndVizportal = RenderWarningsFromGraphAndVizportal;
function RenderWarningsFromGraph(props) {
    var anchored = props.anchoredDataQualityWarning && props.anchoredDataQualityWarning.isActive ?
        [mapFragmentToDetail(props.anchoredDataQualityWarning, true, props.urls)] : [];
    var upstream = props.upstreamDataQualityWarnings.map(function (f) { return mapFragmentToDetail(f, false, props.urls); });
    return React.createElement(RenderWarnings, __assign({}, props, { details: anchored.concat(upstream) }));
}
exports.RenderWarningsFromGraph = RenderWarningsFromGraph;
function RenderWarnings(props) {
    if (props.details.length > 0) {
        return React.createElement(DataQualityStatusChip_1.DataQualityStatusChip, __assign({}, props));
    }
    return null;
}
function mapFragmentOrIndicatorToDetail(either, onContentItem, urls) {
    if (!either.isActive) {
        return null;
    }
    switch (either.kind) {
        case 'fragment':
            return mapFragmentToDetail(either, onContentItem, urls);
        case 'indicator':
            return mapIndicatorToDetail(either, onContentItem, urls);
        default:
            TypescriptHelpers_1.assertUnreachable(either);
            return {};
    }
}
exports.mapFragmentOrIndicatorToDetail = mapFragmentOrIndicatorToDetail;
function mapIndicatorToDetail(indicator, onContentItem, urls) {
    return {
        onContentItem: onContentItem,
        assetName: indicator.assetName,
        assetType: indicator.assetType,
        assetUrl: urls ? indicator.assetUrl(urls) : undefined,
        author: authorFromIndicator(indicator),
        localizedDate: indicator.updatedAt ? Localize_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(indicator.updatedAt)) : '',
        type: DataQualityType_1.stringToDataQualityType(indicator.type),
        message: indicator.message
    };
}
function mapFragmentToDetail(fragment, onContentItem, urls) {
    return {
        onContentItem: onContentItem,
        assetName: assetName(fragment),
        assetType: assetType(fragment),
        assetUrl: urls ? assetUrl(urls, fragment) : undefined,
        author: authorFromWarning(fragment),
        localizedDate: Localize_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(fragment.updatedAt)),
        type: DataQualityType_1.stringToDataQualityType(fragment.warningType),
        message: fragment.message
    };
}
function authorFromIndicator(indicator) {
    return {
        name: indicator.owner.displayName,
        username: indicator.owner.username,
        domain: indicator.owner.domainName || null,
    };
}
function authorFromWarning(warning) {
    return {
        name: warning.author && warning.author.name || warning.authorDisplayName,
        username: warning.author && warning.author.username,
        domain: warning.author && warning.author.domain,
    };
}
function assetName(fragment) {
    if (fragment.asset && fragment.asset.name !== null) {
        return fragment.asset.name;
    }
    else {
        return '';
    }
}
function assetType(fragment) {
    if (fragment.asset && fragment.asset.__typename !== null) {
        return fragment.asset.__typename;
    }
    else {
        return null;
    }
}
function assetUrl(urls, fragment) {
    if (!fragment.asset) {
        return '';
    }
    var asset = fragment.asset;
    switch (asset.__typename) {
        case 'Flow':
            return urls.flowUrl(asset.vizportalUrlId);
        case 'PublishedDatasource':
            return urls.datasourceUrl(asset.vizportalUrlId);
        case 'DatabaseServer':
        case 'CloudFile':
        case 'File':
        case 'WebDataConnector':
            return urls.catalogDatabaseUrl(asset.id);
        case 'DatabaseTable':
            return urls.catalogTableUrl(asset.id);
        default:
            TypescriptHelpers_1.assertUnreachable(asset);
            return '';
    }
}
//# sourceMappingURL=DataQualityWarningFragments.js.map